import React from "react";

const AboutPage = () => {
  return (
    <div className="page">
      <h1>About Page</h1>
    </div>
  );
};

export default AboutPage;
